import "../assets/css/SearchFilter.css"
export const SearchFilter = ({
  filter,
  search,
  onSearchChange,
  onClear,
  checkboxes = [],
}) => {
  return (
    <div className={`filters-bar ${filter ? "open" : ""}`}>
      {/* LEFT */}
      <div className="filters-left">
        <input
          className="input"
          //   type="search"
          placeholder="Search..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />

        {!!search && (
          <button className="pill-button" onClick={onClear}>
            Clear
          </button>
        )}

        {checkboxes.map((cb) => (
          <button
            key={cb.label}
            className={`pill-button ${cb.checked ? "active" : ""}`}
            onClick={cb.onChange}
          >
            {cb.label}
          </button>
        ))}
      </div>

    </div>
  );
};
